import * as actions from './actions'

export const INITIAL_STATE = {
  modalInfos: {
    showModal: false,
    title: null,
    content: null,
    route: null
  },
  vehicle: null,
  tradeIn: null
}

export default function layoutReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.RESET_LAYOUT: {
      return INITIAL_STATE
    }
    case actions.SET_LAYOUT_MODAL_INFO: {
      return { ...state, modalInfos: action.modalInfos }
    }
    case actions.SET_LAYOUT_VEHICLE_PREVIEW: {
      return { ...state, vehicle: action.vehicle }
    }
    case actions.SET_LAYOUT_TRADEIN_PREVIEW: {
      return { ...state, tradeIn: action.tradeIn }
    }
    default:
      return state
  }
}
